@let mainText = customText();
@let minimized = isMinimized();

<gc-error-message
  iconSrc="icons/icon-logger-no-data.svg"
  iconName="icon-logger-no-data"
  [iconSize]="minimized ? '3.75rem' : '5rem'"
  [styleClass]="minimized ? 'gap-[0.75rem]' : ''">
  <div class="flex flex-col gap-[0.5rem] items-center">
    @if (mainText) {
      <div>{{ mainText }}</div>
    } @else {
      <div translate="@@error-display-no-data__text"></div>
    }
    @if (requestError()) {
      <div class="text-[0.75rem] leading-[150%] font-[500]" translate="@@base-error-status-descriptions__failed-unexpected"></div>
    }
  </div>
</gc-error-message>
